import React, { FC, useCallback } from 'react';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { TextField } from '../fields';
import { EditableProps } from './editable-props';
import styles from './multi-line-text-rte.module.css';

interface Props extends Partial<EditableProps<string>> {
  field: TextField;
}

export const MultiLineTextFieldValue: FC<Props> = ({
  field,
  id,
  editable,
  onChange,
}) => {
  const enhancedBreaklineValue = useCallback(() => {
    return field.value?.replaceAll('\n', '<br>');
  }, [field.value]);

  return (
    <RichTextEditor
      id={id}
      autoFocus
      className={styles.multiline__rte}
      data={enhancedBreaklineValue() ?? ''}
      onChange={(_data) => onChange?.(_data)}
      disallowMentions
      readonly={!editable}
      noVariables
      testId={`ag-grid.${field.type}.editor`}
    />
  );
};
